import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunction from "../Data.Function/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dRecord from "../Data.Record/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Restaumatic$dCalendar$dTypes$dAvailability from "../Restaumatic.Calendar.Types.Availability/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dCurrency from "../Restaumatic.I18n.Currency/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dMenu$dV2$dAvailabilityValidation from "../Restaumatic.Menu.V2.AvailabilityValidation/index.js";
import * as Restaumatic$dMenu$dV2$dMenuCatalogue from "../Restaumatic.Menu.V2.MenuCatalogue/index.js";
import * as Restaumatic$dMenu$dV2$dParametric from "../Restaumatic.Menu.V2.Parametric/index.js";
import * as Restaumatic$dMenu$dV2$dPriceView from "../Restaumatic.Menu.V2.PriceView/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId from "../Restaumatic.Menu.V2.Types.ParameterChoiceId/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParameterId from "../Restaumatic.Menu.V2.Types.ParameterId/index.js";
import * as Restaumatic$dPrelude$dSpecular from "../Restaumatic.Prelude.Specular/index.js";
import * as Restaumatic$dSite$dI18n from "../Restaumatic.Site.I18n/index.js";
import * as Restaumatic$dSite$dTranslations$dKeys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
import * as Specular$dExtra from "../Specular.Extra/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dExtra from "../Specular.FRP.Extra/index.js";
import * as Specular$dFRP$dReplaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Web$dHTML from "../Web.HTML/index.js";
import * as Web$dHTML$dWindow from "../Web.HTML.Window/index.js";
const for_ = /* #__PURE__ */ Data$dFoldable.for_(Specular$dInternal$dRIO.applicativeRIO)(Data$dFoldable.foldableMaybe);
const monadFRP = {MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO, MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder};
const whenD = /* #__PURE__ */ Specular$dFRP$dExtra.whenD(monadFRP)(Specular$dDom$dBuilder.monadReplaceBuilder);
const withDynamic_ = /* #__PURE__ */ Specular$dFRP$dReplaceable.withDynamic_(Specular$dDom$dBuilder.monadReplaceBuilder)(monadFRP);
const unions = /* #__PURE__ */ Data$dMap$dInternal.unions(Restaumatic$dMenu$dV2$dTypes$dParameterId.ordParameterId)(Data$dFoldable.foldableArray);
const isSubmap = /* #__PURE__ */ Data$dMap$dInternal.isSubmap(Data$dOrd.ordString)(Data$dEq.eqString);
const shoppingCartIcon = isDecorative => Specular$dDom$dElement.el("span")([
  Specular$dDom$dElement.class_("icon-shopping-cart"),
  isDecorative
    ? Specular$dDom$dElement.attr("aria-hidden")("true")
    : Specular$dDom$dElement.attr("aria-label")(Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.menu.add_to_cart),
        {}
      ))
])(Restaumatic$dPrelude$dSpecular.wempty);
const sectionItemAvailabilityBadge = () => () => params => {
  const $0 = {showInfoIcon: true, ...params};
  const $1 = $0.localDateTime;
  const $2 = $0.showInfoIcon;
  return for_(Data$dMap$dInternal.lookup(Data$dOrd.ordString)($0.availabilityScheduleId)(Data$dRecord.unsafeGet("availabilitySchedules")($0.catalogue)))(schedule => {
    const availabilityStatus = Restaumatic$dCalendar$dTypes$dAvailability.availabilityStatus(Data$dRecord.unsafeGet("availability")(schedule))($1);
    const $3 = Specular$dDom$dElement.el("span")([Specular$dDom$dElement.classes(["label", "label-dish", "m-availability__label", "m-availability__label--unavailable"])])(Specular$dInternal$dRIO.bindImpl((() => {
      if (availabilityStatus.tag === "NotAvailableWholeDay") {
        return Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
          Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.dish_label.unavailable),
          {}
        ));
      }
      if (availabilityStatus.tag === "NotAvailableAtTheTime") {
        return Specular$dDom$dElement.text(Restaumatic$dCalendar$dTypes$dAvailability.formatDailyAvailability(availabilityStatus._1));
      }
      return Restaumatic$dPrelude$dSpecular.wempty;
    })())(() => {
      const $3 = Specular$dDom$dElement.el("span")([
        Specular$dDom$dElement.class_("icon-info-sign"),
        Specular$dDom$dElement.attr("aria-label")(Restaumatic$dI18n._translate(
          Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.theme_defaults.theme.informations),
          {}
        ))
      ])(Restaumatic$dPrelude$dSpecular.wempty);
      if ($2) { return $3; }
      return Specular$dInternal$dRIO.pureImpl();
    }));
    if (!Restaumatic$dCalendar$dTypes$dAvailability.eqAvailabilityStatus.eq(availabilityStatus)(Restaumatic$dCalendar$dTypes$dAvailability.Available)) { return $3; }
    return Specular$dInternal$dRIO.pureImpl();
  });
};
const itemCountBadge = itemCountD => whenD(Specular$dFRP$dBase.functorDynamic.map(v => v > 0)(itemCountD))(Specular$dDom$dElement.el("span")([
  Specular$dDom$dElement.class_("m-item__cart-count")
])(Specular$dDom$dElement.el("span")([Specular$dDom$dElement.class_("m-item__badge"), Specular$dDom$dElement.class_("count")])(Specular$dDom$dElement.dynText(Specular$dFRP$dBase.functorDynamic.map(Data$dShow.showIntImpl)(itemCountD)))));
const displayPriceView = v => {
  if (v.tag === "Constant") { return Specular$dDom$dElement.text(Restaumatic$dI18n$dCurrency.formatCurrency(Restaumatic$dSite$dI18n.getGlobalCurrency())(v._1.value)); }
  if (v.tag === "Range") {
    return Specular$dDom$dElement.text(Restaumatic$dI18n$dCurrency.formatCurrency(Restaumatic$dSite$dI18n.getGlobalCurrency())(v._1.from) + " – " + Restaumatic$dI18n$dCurrency.formatCurrency(Restaumatic$dSite$dI18n.getGlobalCurrency())(v._1.to));
  }
  $runtime.fail();
};
const sectionItemColumn = catalogue => cartProductCountFn => sectionParametersD => menuSectionId => menuSectionItemId => parameterId => choiceId => for_(Restaumatic$dMenu$dV2$dMenuCatalogue.lookupSectionItem(catalogue)(menuSectionId)(menuSectionItemId))(v => {
  if (v.tag === "SingleProduct") {
    const $0 = v._1.customParameterValues;
    const $1 = v._1.itemProduct;
    return for_(Data$dMap$dInternal.lookup(Data$dOrd.ordString)($1)(Data$dRecord.unsafeGet("products")(catalogue)))(product => withDynamic_(sectionParametersD)(sectionParameters => {
      const localParameters = unions([
        Data$dMap$dInternal.$$$Map(
          "Node",
          1,
          1,
          Restaumatic$dMenu$dV2$dTypes$dParameterId.$ParameterId("CustomParameter", parameterId),
          Restaumatic$dMenu$dV2$dTypes$dParameterChoiceId.$ParameterChoiceId("CustomParameterChoice", choiceId),
          Data$dMap$dInternal.Leaf,
          Data$dMap$dInternal.Leaf
        ),
        Restaumatic$dMenu$dV2$dParametric.fromCustomParameterValues($0),
        sectionParameters
      ]);
      return Specular$dInternal$dRIO.bindImpl(for_(Restaumatic$dMenu$dV2$dParametric.isParametricPossibleBoole.isPossible(product.variants)(localParameters)
        ? Restaumatic$dMenu$dV2$dPriceView.priceView(product.price)(localParameters)
        : Data$dMaybe.Nothing)(displayPriceView))(() => Specular$dInternal$dRIO.bindImpl(Specular$dExtra.nbsp)(() => itemCountBadge(cartProductCountFn($1)(localParameters))));
    }));
  }
  return Specular$dInternal$dRIO.pureImpl();
});
const displayAlert = msg => {
  const $0 = Web$dHTML$dWindow.alert(msg);
  return () => {
    const $1 = Web$dHTML.window();
    return $0($1)();
  };
};
const withAvailabilityValidation = catalogue => envD => v => productKey => {
  const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(envD);
  return () => {
    const env = $0();
    const v1 = Restaumatic$dMenu$dV2$dAvailabilityValidation.validateAvailability(catalogue)(env)(productKey);
    if (v1.tag === "Left") {
      const $1 = Web$dHTML.window();
      Web$dHTML$dWindow.alert(v1._1)($1)();
      return v.openProductCreator(productKey)();
    }
    if (v1.tag === "Right") { return v.next(productKey)(); }
    $runtime.fail();
  };
};
const cartProductCount = queryProductId => params => cart => {
  const customParams = Restaumatic$dMenu$dV2$dParametric.onlyCustomParameterValues(params);
  const $0 = Data$dFoldable.find(Data$dFoldable.foldableArray)(product => {
    if (product.key.tag === "MenuProduct") {
      if (product.key._1.parts.length === 1) {
        const $0 = Data$dArray.indexImpl(Data$dMaybe.Just, Data$dMaybe.Nothing, product.key._1.parts, 0);
        const v1 = (() => {
          if ($0.tag === "Just") { return $0._1; }
          $runtime.fail();
        })();
        return v1.productId === queryProductId && isSubmap(customParams)(Data$dMap$dInternal.unsafeUnionWith(
          Data$dOrd.ordString.compare,
          Data$dFunction.const,
          v1.customParameters,
          product.key._1.customParameters
        ));
      }
      return false;
    }
    return false;
  })(cart.products);
  if ($0.tag === "Nothing") { return 0; }
  if ($0.tag === "Just") { return $0._1.quantity; }
  $runtime.fail();
};
const cartComboCount = queryComboId => cart => {
  const $0 = Data$dFoldable.find(Data$dFoldable.foldableArray)(product => {
    if (product.key.tag === "MenuCombo") { return product.key._1.comboId === queryComboId; }
    return false;
  })(cart.products);
  if ($0.tag === "Nothing") { return 0; }
  if ($0.tag === "Just") { return $0._1.quantity; }
  $runtime.fail();
};
const caretIcon = /* #__PURE__ */ Specular$dDom$dElement.el("span")([/* #__PURE__ */ Specular$dDom$dElement.class_("caret")])(Restaumatic$dPrelude$dSpecular.wempty);
export {
  caretIcon,
  cartComboCount,
  cartProductCount,
  displayAlert,
  displayPriceView,
  for_,
  isSubmap,
  itemCountBadge,
  monadFRP,
  sectionItemAvailabilityBadge,
  sectionItemColumn,
  shoppingCartIcon,
  unions,
  whenD,
  withAvailabilityValidation,
  withDynamic_
};
